<template>
  <a-spin :spinning="loading">
    <div
      class="courseDetails"
      :style="{
        backgroundImage: 'url(' + styleObj.bgi + ')',
      }"
    >
      <common-header></common-header>
      <div class="courseDetailsContent">
        <div class="path">
          <address-bar :path="path" :categoryIndex="categoryIndex"></address-bar>
        </div>
        <div class="container">
          <div class="left">
            <img class="imgUrl" :src="courseDetails.imgUrl" alt="" />
            <div class="title">{{ courseDetails.catName }}</div>
            <div class="description">
              <span>课程简介：</span>{{ courseDetails.description || "无简介" }}
            </div>
            <!-- 收藏按钮 -->
            <!-- <a-button
            type="primary"
            :class="['collectBtn', courseDetails.status ? 'collected' : '']"
            :style="{
              backgroundColor: courseDetails.status ? styleObj.color : '',
            }"
            @click="handleCollect(courseDetails.catId)"
          >
            <img
              :src="
                courseDetails.status
                  ? imagePath.collectedBtn
                  : imagePath.collectBtn
              "
              alt=""
            />
            <span>收藏</span>
          </a-button> -->
          </div>
          <div class="right">
            <div class="title" :style="{ backgroundImage: 'url(' + path.secSubLongImg + ')' }">课程资料列表</div>
            <div class="list" v-if="courseDetails.slidesDOPage">
              <div
                class="item cp"
                v-for="item in courseDetails.slidesDOPage.entityList"
                :key="item.slidesId"
                :style="{ backgroundColor: styleObj.ListBGC, borderColor: styleObj.color }"
                @click="goLookPPT(item.slidesId)"
              >
                <span>{{ item.slidesName }}</span>
                <img class="listBtnUrl cp" :src="styleObj.listBtnUrl" alt="" />
                <img
                  class="listBtnUrl2 cp"
                  :src="styleObj.listBtnUrl2"
                  alt=""
                />
              </div>
            </div>
            <a-pagination
              class="pagination"
              v-model="queryParams.page"
              :page-size-options="pageSizeOptions"
              show-size-changer
              :total="queryParams.total"
              :show-total="(total) => `共${total}条`"
              :page-size="queryParams.pageSize"
              :default-current="1"
              @change="onChange"
              @showSizeChange="onShowSizeChange"
            />
          </div>
        </div>
      </div>
    </div>
  </a-spin>
</template>

<script>
import imagePath from "@/utils/imagePath";
import { getCourseDetails, getHomeDetails, queryCategoryName, queryPath } from "@/api/home";
import { collectCourse, deleteCollectCourse } from "@/api/my";
import CommonHeader from "@/components/header/index";
import AddressBar from "@/components/addressBar";
import { getColorByClassNum } from "@/utils/getColor.js";
// import { Base64 } from "@/utils/tool.js";

export default {
  name: "CourseDetails", // 课程详情
  components: {
    CommonHeader,
    AddressBar
  },
  data() {
    return {
      pageSizeOptions: ["6", "12", "18", "24", "30"],
      imagePath,
      courseDetails: {}, // 课程详情
      // 分页参数
      queryParams: {
        total: 0,
        page: 1,
        pageSize: 6
      },
      // 本页样式对象
      styleObj: {
        bgi: "", // 背景图
        color: "", // 收藏按钮样式颜色
        listHeadUrl: "", // 列表头部背景图
        ListBGC: "", // 列表背景颜色
        listBtnUrl: "", // 列表按钮路径
        listBtnUrl2: "" // 鼠标经过时，列表按钮路径
      },
      path: {},
      loading: false,
      categoryIndex: 0
    };
  },
  computed: {
    classNum() {
      return this.$route.query.classNum * 1 || sessionStorage.getItem("classNum") * 1
    }
  },
  async created() {
    sessionStorage.setItem("classNum", this.classNum);
    await this.getCourseDetails();
    if (this.$route.query.id) await this.queryPath(this.$route.query.id);
    await this.queryCategoryName()
    this.colorByClassNum();
  },
  updated() {
    const color = this.categoryIndex > 3 && this.classNum == 1? getColorByClassNum(0): getColorByClassNum(this.classNum);
    const pagination = document.getElementsByClassName("ant-pagination-item");
    if (pagination.length > 0) {
      for (let i = 0; i < pagination.length; i++) {
        pagination[i].style.borderColor = color.selected;
        pagination[i].style.backgroundColor = "#fff";
        pagination[i].getElementsByTagName("a")[0].style.color = color.selected;
      }
    }
    const paginationActive = document.getElementsByClassName("ant-pagination-item-active");
    if (paginationActive.length > 0) {
      for (let i = 0; i < paginationActive.length; i++) {
        paginationActive[i].style.borderColor = color.selected;
        paginationActive[i].style.backgroundColor = color.selected;
        paginationActive[i].getElementsByTagName("a")[0].style.color = "#fff";
      }
    }
    const paginationPrev = document
      .getElementsByClassName("ant-pagination-prev")[0]
      .getElementsByTagName("a")[0];
    paginationPrev.style.borderColor = color.selected;
    paginationPrev.style.color = color.selected;

    const paginationNext = document
      .getElementsByClassName("ant-pagination-next")[0]
      .getElementsByTagName("a")[0];
    paginationNext.style.borderColor = color.selected;
    paginationNext.style.color = color.selected;

    const paginationDisabled = document
      .getElementsByClassName("ant-pagination-disabled")[0]
      .getElementsByTagName("a")[0];
    paginationDisabled.style.borderColor = "#d9d9d9";
    paginationDisabled.style.color = "rgba(0, 0, 0, 0.25)";

    const paginationSelection = document.getElementsByClassName(
      "ant-select-selection"
    )[0];
    paginationSelection.style.borderColor = color.selected;
    paginationSelection.style.color = color.selected;
    paginationSelection.style.boxShadow = 'none';
    // console.log(paginationSelection, "paginationPrev");
  },
  methods: {
    async queryCategoryName() {
      this.loading = true;
      const { status, data, msg } = await queryCategoryName(0);
      if (status === 200) {
        this.categoryIndex = data.findIndex(item => item.catId === Number(this.path.firSubId));
        console.log(this.categoryIndex,'categoryIndex');
      } else {
        this.$message.error(msg);
      }
      this.loading = false;
    },
    async queryPath(id) {
      const { data, status, msg } = await queryPath(id);
      if (status === 200) {
        this.path = data;
        // console.log(data, "queryPath");
      } else {
        this.$message.error(msg);
      }
    },
    goLookPPT(id) {
      this.$router.push({ path: "/lookPPT", query: { id: id }});
    },
    colorByClassNum() {
      if(this.categoryIndex < 4) {
        switch (this.classNum * 1) {
          case 0:
            this.styleObj.bgi = this.imagePath.class0;
            this.styleObj.color = "#ff6f5b";
            this.styleObj.ListBGC = "#FFE7E3";
            this.styleObj.listBtnUrl = this.imagePath.list01;
            this.styleObj.listBtnUrl2 = this.imagePath.list02;
            this.styleObj.listHeadUrl = this.imagePath.listHead0;
            break;
          case 1:
            this.styleObj.bgi = this.imagePath.class1;
            this.styleObj.color = "#57c500";
            this.styleObj.ListBGC = "#E2F9CF";
            this.styleObj.listBtnUrl = this.imagePath.list11;
            this.styleObj.listBtnUrl2 = this.imagePath.list12;
            this.styleObj.listHeadUrl = this.imagePath.listHead1;
            break;
          case 2:
            this.styleObj.bgi = this.imagePath.class2;
            this.styleObj.color = "#549aff";
            this.styleObj.ListBGC = "#DAF3FF";
            this.styleObj.listBtnUrl = this.imagePath.list21;
            this.styleObj.listBtnUrl2 = this.imagePath.list22;
            this.styleObj.listHeadUrl = this.imagePath.listHead2;
            break;
          case 3:
            this.styleObj.bgi = this.imagePath.class3;
            this.styleObj.color = "#cf75ff";
            this.styleObj.ListBGC = "#F6DFFF";
            this.styleObj.listBtnUrl = this.imagePath.list31;
            this.styleObj.listBtnUrl2 = this.imagePath.list32;
            this.styleObj.listHeadUrl = this.imagePath.listHead3;
            break;
          default:
            return
        }
      }else {
        console.log('走着了');
        switch (this.classNum * 1) {
          case 0:
            this.styleObj.bgi = this.imagePath.class0;
            this.styleObj.color = "#ff6f5b";
            this.styleObj.ListBGC = "#FFE7E3";
            this.styleObj.listBtnUrl = this.imagePath.list01;
            this.styleObj.listBtnUrl2 = this.imagePath.list02;
            this.styleObj.listHeadUrl = this.imagePath.listHead0;
            break;
          case 1:
            this.styleObj.bgi = this.imagePath.class0;
            this.styleObj.color = "#ff6f5b";
            this.styleObj.ListBGC = "#FFE7E3";
            this.styleObj.listBtnUrl = this.imagePath.list01;
            this.styleObj.listBtnUrl2 = this.imagePath.list02;
            this.styleObj.listHeadUrl = this.imagePath.listHead0;
            break;
          // case 1:
          //   this.styleObj.bgi = this.imagePath.class1;
          //   this.styleObj.color = "#57c500";
          //   this.styleObj.ListBGC = "#E2F9CF";
          //   this.styleObj.listBtnUrl = this.imagePath.list11;
          //   this.styleObj.listBtnUrl2 = this.imagePath.list12;
          //   this.styleObj.listHeadUrl = this.imagePath.listHead1;
          //   break;
          case 2:
            this.styleObj.bgi = this.imagePath.class2;
            this.styleObj.color = "#549aff";
            this.styleObj.ListBGC = "#DAF3FF";
            this.styleObj.listBtnUrl = this.imagePath.list21;
            this.styleObj.listBtnUrl2 = this.imagePath.list22;
            this.styleObj.listHeadUrl = this.imagePath.listHead2;
            break;
          case 3:
            this.styleObj.bgi = this.imagePath.class3;
            this.styleObj.color = "#cf75ff";
            this.styleObj.ListBGC = "#F6DFFF";
            this.styleObj.listBtnUrl = this.imagePath.list31;
            this.styleObj.listBtnUrl2 = this.imagePath.list32;
            this.styleObj.listHeadUrl = this.imagePath.listHead3;
            break;
          default:
            return
        }
      }
    },
    async handleCollect(id) {
      const { data, status, msg } = this.courseDetails.status
        ? await collectCourse(id)
        : await deleteCollectCourse(id);
      await this.getCourseDetails();
      if (status === 200) {
        this.$message.success(data);
      } else {
        this.$message.error(msg);
      }
    },
    onChange(page) {
      this.queryParams.page = page;
      this.getCourseDetails();
    },
    onShowSizeChange(page, pageSize) {
      this.queryParams.page = page;
      this.queryParams.pageSize = pageSize;
      this.getCourseDetails();
    },
    async getCourseDetails() {
      this.loading = true;
      const { data, status, msg } = await getCourseDetails(
        this.$route.query.id,
        this.queryParams.page,
        this.queryParams.pageSize
      );
      if (status === 200) {
        this.courseDetails = data;
        if(data.slidesDOPage) {
          const {currentPage, pageSize, total} = data.slidesDOPage
          this.queryParams.page = currentPage;
          this.queryParams.pageSize = pageSize;
          this.queryParams.total = total;
        }
      } else {
        this.$message.error(msg);
      }
      this.loading = false;
    }
  }
};
</script>

<style lang="less" scoped>
.courseDetails {
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  // overflow: hidden;
  .courseDetailsContent {
    margin: 0 auto;
    padding-bottom: 104px;
    width: 1200px;
    height: 100%;

    .path {
      margin-top: 64px;
      color: #333333;
      font-size: 24px;

      .catName {
        font-weight: 600;
      }
    }

    .container {
      display: flex;

      .left {
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        margin-top: 159px;
        height: 551px;
        box-sizing: border-box;

        .imgUrl {
          width: 300px;
          height: 167px;
          object-fit: cover;
          border-radius: 10px;
        }

        .title {
          margin-top: 50px;
          width: 300px;
          font-size: 24px;
          font-weight: 550;
          color: #333333;
          // 单行文本溢出隐藏
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .description {
          margin-top: 20px;
          width: 300px;
          // 多行文本溢出隐藏
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          overflow: hidden;

          span {
            font-weight: 550;
          }
        }

        .collectBtn {
          display: flex;
          justify-content: center;
          align-items: center;
          position: absolute;
          bottom: 0;
          width: 206px;
          height: 62px;
          line-height: 62px;
          border-radius: 31px;
          color: #999999;
          font-size: 22px;
          border: 2px solid #d6d6d6;
          background-color: #fff;

          img {
            margin-right: 12px;
            width: 22px;
            height: 22px;
          }
        }

        .collected {
          border: 0;
          color: #ffffff;
        }
      }

      .right {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        position: relative;
        margin-left: 20px;
        margin-top: 40px;
        height: 739px;

        .title {
          margin-bottom: 40px;
          margin-left: -20px;
          padding-left: 208px;
          width: 890px;
          height: 78px;
          line-height: 92px;
          background-size: cover;
          background-repeat: no-repeat;
          font-size: 24px;
          color: #333333;
          font-weight: 550;
          box-sizing: border-box;
          border-radius: 10px;
        }

        .list {
          height: 576px;
          overflow: auto;
          scrollbar-width: none; /* Firefox */
          -ms-overflow-style: none; /* IE 10+, edge */
          &::-webkit-scrollbar {
            display: none; /* Chrome Safari */
            // 或者 width: 0;
          }

          .item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 24px;
            padding: 0 50px 0 30px;
            width: 880px;
            height: 72px;
            border-radius: 10px;
            // filter: blur(40px);
            border: 0 solid;
            box-sizing: border-box;

            span {
              font-size: 18px;
              color: #333333;
            }

            .listBtnUrl,
            .listBtnUrl2 {
              width: 32px;
              height: 32px;
            }

            .listBtnUrl2 {
              display: none;
            }
          }

          .item:hover {
            padding: 0 49px 0 29px;
            border: 1px solid;

            .listBtnUrl {
              display: none;
            }

            .listBtnUrl2 {
              display: block;
            }
          }
        }

        .pagination {
          position: absolute;
          bottom: 0;
          right: 0;

          /deep/ .ant-pagination-options-size-changer.ant-select {
            margin-right: 0;
          }

          /deep/ .ant-pagination-item:hover {
            border-color: #d9d9d9;

            a {
              color: rgba(0, 0, 0, 0.65);
            }
          }

          /deep/ .ant-pagination-next:hover,
          /deep/ .ant-pagination-prev:hover {
            .ant-pagination-item-link {
              color: rgba(0, 0, 0, 0.65);
              border-color: #d9d9d9;
            }
          }

          /deep/ .ant-select-selection:hover {
            color: rgba(0, 0, 0, 0.65);
            border-color: #d9d9d9;
          }
        }
      }
    }
  }
}

/deep/ .ant-pagination-item {
  border-radius: 8px;
}
</style>
